module.exports = __webpack_public_path__ + "img/kanbangujia.9fd7f558.svg";